import React from 'react';
import { useDispatch } from 'react-redux';
import { setServiceType, openServiceDialog } from '../../store/serviceBookingSlice';
import priestImage from '../../assets/images/quickservices/priest.png';
import tentImage from '../../assets/images/quickservices/tent.png';
import cateringImage from '../../assets/images/quickservices/catering.png';
import './ServiceButtons.css';

const ServiceButtons = ({
  showPriest = true,
  showCatering = true,
  showTent = true,
  isLoggedIn = false,
  showAlways = false, 
  hideForLoggedIn = false,
  showOrSeparator = true,
  onServiceSelect,
  children 
}) => {
  const dispatch = useDispatch();

  const handleServiceButtonClick = (serviceType) => {
    console.log("Selected service type:", serviceType);

    if (onServiceSelect) {
    onServiceSelect(serviceType); 
    return;
  }

    dispatch(setServiceType(serviceType));
    dispatch(openServiceDialog());
  };

  // Hide logic
  if (!showAlways && hideForLoggedIn && isLoggedIn) {
    return null;
  }

  return (
    <>
      <div className="provider-services2">
        {showPriest == true && <div
          className="servicesinfo"
          onClick={() => handleServiceButtonClick('priest')}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === 'Enter' && handleServiceButtonClick('priest')}
        >
          <div className="servicetext">
            <span className="title">Book Priest</span>
            <span className="subtitle">For every ritual</span>
          </div>
          <img
            src={priestImage}
            alt="priest"
            className="serviceImage"
          />
        </div>}

        {showCatering == true && (
          <div
            className="servicesinfo"
            onClick={() => handleServiceButtonClick('catering')}
            role="button"
            tabIndex={0}
            onKeyPress={(e) => e.key === 'Enter' && handleServiceButtonClick('catering')}
        >
          <div className="servicetext">
            <span className="title">Order Catering</span>
            <span className="subtitle">Delicious & fresh</span>
          </div>
          <img
            src={cateringImage}
            alt="catering"
            className="serviceImage"
          />
        </div>)}

        {showTent == true && ( <div
          className="servicesinfo"
          onClick={() => handleServiceButtonClick('tent')}
          role="button"
          tabIndex={0}
          onKeyPress={(e) => e.key === 'Enter' && handleServiceButtonClick('tent')}
        >
          <div className="servicetext">
            <span className="title">Rent tent houses</span>
            <span className="subtitle">Decor & essentials</span>
          </div>
          <img
            src={tentImage}
            alt="tent"
            className="serviceImage"
          />
        </div>)}

        {children}

      </div>

      {/* Conditionally show the "Or" separator */}
      {showOrSeparator && !isLoggedIn && <span style={{ margin: "8px" }}>Or</span>}
    </>
  );
};

export default ServiceButtons;